import React from "react";
import "./style.css";
import moment from "moment";
import { newImgUrl, baseURL } from "../../constants/index";
import { getFileById } from "../../services/index";
import { Link } from "react-router-dom";
export class RichText extends React.Component {
  constructor(props) {
    super(props);
    let article = props.fileinfo;
    // console.log(article);
    this.article = props.fileinfo;
    this.state = {
      dom: article.journalism_content,
      fileid: article.id,
      abs: article.abstracts,
      title: article.name,
      category: article.journalism_type,
      createtime: moment(article.journalism_time).format("YYYY-MM-DD HH:mm"),
      relevantFileArr: [],
    };
  }
  componentDidMount() {
    this.article.relevant_file &&
      this.getRelevantFile(this.article.relevant_file);
  }
  getRelevantFile(data) {
    let idArr = data.indexOf(",") !== -1 ? data.split(",") : [data];
    let arr = [];
    idArr.map((i, index, array) => {
      getFileById({
        id: parseInt(i),
      }).then((res) => {
        arr.push(res.data[0]);
        if (index == array.length - 1) {
          let newArr = [];
          newArr = Object.assign([], arr);
          this.setState({
            relevantFileArr: newArr,
          });
        }
      });
    });
  }
  getDom(dom) {
    const reg = new RegExp("/repository/image/", "g");
    return dom.replace(reg, baseURL + newImgUrl);
  }
  downLoadFile(data) {
    window.open(baseURL + "/estar_system/fileDownload/download/" + data.id);
  }
  render() {
    return (
      <div className="rt_box">
        <Link to={localStorage.getItem("typeName")=="区域遥感"?"/sensor":"/news"}>
          <div className="backBtn" onClick={this.back}>
            返回
          </div>
        </Link>

        <div className="detail">
          <span className="d_title">{this.state.title}</span>
          <span className="d_tag1">分类：</span>
          <span className="d_category">{this.state.category}</span>
          <span className="d_time">{this.state.createtime}</span>
        </div>
        <div className="abs">{"【摘要】：" + this.state.abs}</div>
        <div
          dangerouslySetInnerHTML={{ __html: this.getDom(this.state.dom) }}
        ></div>
        {/* <div className="sibling_news_div">
          <div
            className={
              this.state.ptitle === ""
                ? "pre_news_div not_view"
                : "pre_news_div"
            }
          >
            <a className="sibling_text_link" href="/news">
              {this.state.ptitle}
            </a>
            <span className="sibling_text">&nbsp;上一篇</span>
          </div>
          <div
            className={
              this.state.ntitle === ""
                ? "next_news_div not_view"
                : "next_news_div"
            }
          >
            <a className="sibling_text_link" href="/news">
              {this.state.ntitle}
            </a>
            <span className="sibling_text">&nbsp;下一篇</span>
          </div>
        </div> */}
        <div className="attach">
          <div className="attach_info">
            <div>相关附件</div>
            <ul style={{ marginLeft: "70px", listStyle: "none" }}>
              {this.state.relevantFileArr &&
                this.state.relevantFileArr.length > 0 &&
                this.state.relevantFileArr.map((i) => {
                  return (
                    <li key={i.id}>
                      <div
                        className="downLoadFile"
                        onClick={() => this.downLoadFile(i)}
                      >
                        {i.name}
                      </div>
                    </li>
                  );
                })}
            </ul>
          </div>
          {/* <div className="attach_desc">暂时没有内容信息显示</div> */}
        </div>
      </div>
    );
  }
}
